import { Flex, Typography } from "antd";
import styled from "styled-components";
import { AgentList } from "./components/AgentList";
import { SessionList } from "./components/SessionList";

const StyledComponent = styled.div``;

export const SessionPage = () => {
  return (
    <StyledComponent className="page-shell">
      <Flex className="page-header" vertical>
        <Typography.Text className="page-eyebrow">RUNTIME</Typography.Text>
        <Typography.Title level={2} className="page-title">运行环境</Typography.Title>
        <Typography.Text type="secondary">管理执行节点与持久化浏览器会话。</Typography.Text>
      </Flex>
      <Flex vertical gap={20}>
        <div className="section-block"><AgentList /></div>
        <div className="section-block"><SessionList /></div>
      </Flex>
    </StyledComponent>
  );
}
